// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__-679z"};